module.exports = __webpack_public_path__ + "static/media/002-cloud.6d156d74.svg";